/* Panier NMB (17/10) : tiroir + page /cart rendus depuis /cart.js.
   API publique : window.NMBCart.open(), .close(), .refresh(), .applyCode(code), .addForm(form, code) */
(function () {
  'use strict';
  var cfgEl = document.getElementById('nmbc-cfg');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var P = C.products || {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var dr = document.getElementById('nmbc');
  var pg = document.querySelector('[data-nmbc-page]');
  var cart = null, busy = false, codeOpen = false, codeErr = '', err = '', lastFocus = null;

  function fmt(c) { return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function up(s) { return String(s).toUpperCase(); }
  function img(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  var muting = 0;
  function api(path, body) {
    if (body) { muting++; }
    var done = function () { if (body) setTimeout(function () { muting--; }, 500); };
    return fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { done(); return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); }, function (e) { done(); throw e; });
  }
  function names(title, handle) {
    var t = String(title || '').replace(' — ', ' : ').replace(' – ', ' : ');
    var i = t.indexOf(':'), n = i > -1 ? t.slice(0, i).trim() : t.trim(), s = i > -1 ? t.slice(i + 1).trim() : '';
    if (handle === 'lotion-maman') { n = 'Lotion pousse et anti-chute Post-Partum'; s = 'Booster capillaire après bébé'; }
    if (s) s = s.charAt(0).toUpperCase() + s.slice(1);
    return [n, s];
  }
  function ship() {
    var d = new Date(), add = function (n) { var x = new Date(d), c = 0; while (c < n) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) c++; } return x; };
    var o = { weekday: 'short', day: 'numeric', month: 'short' };
    return 'Reçu entre le ' + add(2).toLocaleDateString('fr-FR', o) + ' et le ' + add(4).toLocaleDateString('fr-FR', o);
  }
  function codesList() { return ((cart && cart.discount_codes) || []).map(function (d) { return d.code; }); }
  function codeAmt(code) {
    var a = 0, lc = String(code).toLowerCase();
    cart.items.forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (d) {
        if (String(d.discount_application && d.discount_application.title).toLowerCase() === lc) a += d.amount;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (String(d.title).toLowerCase() === lc) a += d.total_allocated_amount; });
    return a;
  }
  function priceHTML(p) { return fmt(p.pr) + (p.c > p.pr ? ' <s>' + fmt(p.c) + '</s>' : ''); }

  /* ---------- rendu ---------- */
  function bar() {
    var T = C.threshold; if (!T) return '';
    var tot = cart.total_price, ok = tot >= T, G = C.gift && C.gift.t, goal = (ok && G) ? G : T;
    var pct = Math.min(100, Math.round(tot / goal * 100)), msg;
    if (!ok) msg = 'Plus que <b>' + fmt(T - tot) + '</b> pour la <b>livraison offerte</b> 🚚';
    else if (G && tot < G) msg = '✓ Livraison offerte · plus que <b>' + fmt(G - tot) + '</b> pour : <b>' + esc(C.gift.label) + '</b>';
    else if (G) msg = '🎁 <b>' + esc(C.gift.label) + '</b> débloqué · livraison offerte';
    else msg = '✓ Ta <b>livraison est offerte</b> 🚚';
    return '<div class="nmbc__bar' + (ok ? ' is-ok' : '') + '"><p>' + msg + '</p><div class="nmbc__trk"><i style="width:' + pct + '%"></i></div></div>';
  }
  /* compte à rebours : uniquement avec une vraie date de fin, et si le code de l'offre est appliqué */
  var cdTimer = null;
  function cdEnd() { var t = C.cd && C.cd.end ? Date.parse(C.cd.end) : NaN; return isNaN(t) ? 0 : t; }
  function cdShow() {
    var end = cdEnd(); if (!end || Date.now() >= end || !cart || !cart.items.length) return false;
    if (!C.cd.code) return true;
    return (cart.discount_codes || []).some(function (d) { return d.applicable && up(d.code) === up(C.cd.code); });
  }
  function cdText() {
    var ms = Math.max(0, cdEnd() - Date.now()), s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
    var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
    return (d > 0 ? d + ' j ' : '') + p2(h) + ' h ' + p2(m) + ' min ' + p2(sec) + ' s';
  }
  function cdHTML() {
    if (!cdShow()) return '';
    return '<div class="nmbc__cdn" role="timer"><span class="nmbc__cdl">⏳ <b>' + esc(C.cd.label) + '</b><br>se termine dans</span><span class="nmbc__cdt" data-nmbc-t>' + cdText() + '</span></div>';
  }
  function cdTick() {
    clearInterval(cdTimer); cdTimer = null;
    if (!document.querySelector('[data-nmbc-t]')) return;
    cdTimer = setInterval(function () {
      if (Date.now() >= cdEnd()) { clearInterval(cdTimer); cdTimer = null; render(); return; }
      var t = cdText(); document.querySelectorAll('[data-nmbc-t]').forEach(function (el) { el.textContent = t; });
    }, 1000);
  }
  function nudge() {
    var T = C.threshold, tot = cart.total_price; if (!T || tot >= T) return null;
    var b = null;
    cart.items.forEach(function (i) {
      var u = Math.round(i.final_line_price / i.quantity);
      if (tot + u >= T && (!b || u < b.u)) b = { key: i.key, u: u, q: i.quantity };
    });
    return b;
  }
  function line(i, nd) {
    var nm = names(i.product_title, i.handle), vt = (!i.product_has_only_default_variant && i.variant_title) ? i.variant_title : '';
    return '<li class="nmbc__it" data-key="' + esc(i.key) + '">' +
      '<a class="nmbc__im" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(img(i.image, 240)) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
      '<div><a class="nmbc__nm" href="' + esc(i.url) + '">' + esc(nm[0]) + '</a>' +
      (nm[1] ? '<span class="nmbc__sb">' + esc(nm[1]) + '</span>' : '') + (vt ? '<span class="nmbc__sb">' + esc(vt) + '</span>' : '') + (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan ? '<span class="nmbc__sb">Abonnement · ' + esc(i.selling_plan_allocation.selling_plan.name) + '</span>' : '') +
      '<div class="nmbc__row"><div class="nmbc__q"><button type="button" data-q="-1" aria-label="Retirer un ' + esc(nm[0]) + '">−</button><span>' + i.quantity + '</span><button type="button" data-q="1" aria-label="Ajouter un ' + esc(nm[0]) + '">+</button></div>' +
      '<button type="button" class="nmbc__rm" data-rm>Retirer</button></div></div>' +
      '<div class="nmbc__pr">' + (i.original_line_price > i.final_line_price ? '<s>' + fmt(i.original_line_price) + '</s>' : '') + fmt(i.final_line_price) + '</div>' +
      (nd ? '<div class="nmbc__ndg"><p>Prends-en ' + (nd.q + 1) + ' : ta <b>livraison est offerte</b></p><button type="button" class="nmbc__b2" data-q="1">+1 · ' + fmt(nd.u) + '</button></div>' : '') +
      '</li>';
  }
  function pick() {
    var inCart = {}, r = null;
    cart.items.forEach(function (i) { inCart[i.handle] = 1; });
    (C.pairs || []).some(function (x) {
      if (inCart[x.on] && !inCart[x.p] && P[x.p] && P[x.p].a && P[x.p].v) { r = { p: P[x.p], pitch: x.pitch || P[x.p].pi }; return true; }
      return false;
    });
    if (!r) (C.def || []).some(function (h) {
      if (!inCart[h] && P[h] && P[h].a && P[h].v) {
        var pr = (C.pairs || []).filter(function (x) { return x.p === h && x.pitch; })[0];
        r = { p: P[h], pitch: pr ? pr.pitch : (h === (C.def || [])[0] ? P[h].pi : '') }; return true;
      }
      return false;
    });
    return r;
  }
  function sugg() {
    if (!C.sugg) return '';
    var s = pick(); if (!s) return '';
    var p = s.p, T = C.threshold, tot = cart.total_price, cross = T && tot < T && tot + p.pr >= T;
    return '<div class="nmbc__sg"><p class="nmbc__k">Complète ta routine</p><div class="nmbc__sgc">' +
      '<a href="' + esc(p.u) + '">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
      '<div><a href="' + esc(p.u) + '"><b>' + esc(p.n) + '</b></a>' + (s.pitch ? '<span>' + esc(s.pitch) + '</span>' : '') + '<em>' + priceHTML(p) + '</em></div>' +
      '<button type="button" class="nmbc__b2" data-add="' + p.v + '">Ajouter</button></div>' +
      (cross ? '<p class="nmbc__sgn">Avec lui, ta livraison est offerte</p>' : '') + '</div>';
  }
  /* Code suggéré : le meilleur code configuré qui s'applique au panier et fait mieux que la remise actuelle
     (les codes NMB ne se cumulent pas avec les autres remises, Shopify garde la meilleure). */
  function promoPick() {
    if (!C.promos || !C.promos.length || !cart || !cart.items.length) return null;
    var now = Date.now(), have = codesList().map(up), best = null;
    C.promos.forEach(function (p) {
      if (!p.pct || have.indexOf(up(p.code)) > -1) return;
      if (p.end) { var t = Date.parse(p.end); if (!isNaN(t) && t < now) return; }
      if (p.min && cart.original_total_price < p.min) return;
      var base = 0;
      cart.items.forEach(function (i) { if (!p.on || !p.on.length || p.on.indexOf(i.handle) > -1) base += i.original_line_price; });
      var save = Math.floor(base * p.pct / 100);
      if (save <= 0 || save - (cart.total_discount || 0) < 100) return; /* moins d'1 € de gain : on ne dérange pas */
      if (!best || save > best.save) best = { p: p, save: save };
    });
    return best;
  }
  function promoHTML() {
    var b = promoPick(); if (!b) return '';
    var end = '';
    if (b.p.end) { var t = Date.parse(b.p.end); if (!isNaN(t)) end = ' · jusqu’au ' + new Date(t).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', timeZone: 'Europe/Paris' }); }
    return '<div class="nmbc__sug"><div><p class="nmbc__sugk">🎁 Code disponible</p><p class="nmbc__sugt"><b>' + esc(b.p.code) + '</b>' + (b.p.label ? ' · ' + esc(b.p.label) : '') + '</p>' +
      '<p class="nmbc__sugs">' + (cart.total_discount > 0 ? 'Mieux que ta remise actuelle : ' + fmt(b.save - cart.total_discount) + ' de moins' : 'Tu économises ' + fmt(b.save)) + end + '</p></div>' +
      '<button type="button" class="nmbc__b2" data-sugcode="' + esc(b.p.code) + '">Appliquer</button></div>';
  }
  function codes() {
    var dc = cart.discount_codes || [], h = promoHTML();
    if (dc.length) {
      h += '<div class="nmbc__chips">' + dc.map(function (d) {
        var a = d.applicable ? codeAmt(d.code) : 0;
        return '<span class="nmbc__chip' + (d.applicable ? '' : ' is-off') + '">' + esc(d.code) +
          (d.applicable ? (a ? ' · −' + fmt(a) : ' · appliqué') : ' · ne s’applique pas') +
          '<button type="button" data-rmcode="' + esc(d.code) + '" aria-label="Retirer le code ' + esc(d.code) + '">×</button></span>';
      }).join('') + '</div>';
    }
    h += '<details class="nmbc__cd"' + (codeOpen ? ' open' : '') + '><summary>' + (dc.length ? 'Ajouter un autre code' : 'Tu as un code promo ?') + '</summary>' +
      '<form class="nmbc__cf" data-codef><input name="c" placeholder="Code promo" autocomplete="off" autocapitalize="characters" aria-label="Code promo" required><button type="submit">Appliquer</button></form>' +
      '<p class="nmbc__cerr" role="alert"' + (codeErr ? '' : ' hidden') + '>' + esc(codeErr) + '</p></details>';
    return '<div class="nmbc__codes">' + h + '</div>';
  }
  function sum(compact) {
    var c = cart, ok = C.threshold && c.total_price >= C.threshold, h = '<div class="nmbc__sum">';
    if (compact) {
      h += '<p class="nmbc__tot"><span>Total</span><span>' + (c.total_discount > 0 ? '<s>' + fmt(c.original_total_price) + '</s>' : '') + '<b>' + fmt(c.total_price) + '</b></span></p></div>' +
        '<a class="nmbc__go" href="' + root + 'checkout">Paiement sécurisé · ' + fmt(c.total_price) + '</a>';
      return h;
    }
    if (c.total_discount > 0) h += '<p><span>Sous-total</span><span>' + fmt(c.original_total_price) + '</span></p><p class="is-d"><span>Remises</span><span>−' + fmt(c.total_discount) + '</span></p>';
    h += '<p class="nmbc__tot"><span>Total</span><b>' + fmt(c.total_price) + '</b></p>' +
      '<p class="nmbc__shp">' + (ok ? '✓ Livraison offerte' : 'Livraison calculée à l’étape suivante') + '</p></div>' +
      '<a class="nmbc__go" href="' + root + 'checkout">Paiement sécurisé · ' + fmt(c.total_price) + '</a>';
    return h;
  }
  function emptyHTML() {
    var bs = (C.empty || []).map(function (h) {
      var p = P[h]; if (!p || !p.a || !p.v) return '';
      return '<li class="nmbc__sgc"><a href="' + esc(p.u) + '">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
        '<div><a href="' + esc(p.u) + '"><b>' + esc(p.n) + '</b></a><em>' + priceHTML(p) + '</em></div>' +
        '<button type="button" class="nmbc__b2" data-add="' + p.v + '">Ajouter</button></li>';
    }).join('');
    return '<div class="nmbc__empty"><p class="nmbc__et">Ton panier est vide</p><p>Pas sûre de quoi choisir ? Le diagnostic te conseille ta routine en 2 minutes.</p>' +
      '<a class="nmbc__go" href="' + esc(C.quiz) + '">Faire mon diagnostic</a>' +
      (bs ? '<p class="nmbc__k">Nos best-sellers</p><ul class="nmbc__bs">' + bs + '</ul>' : '') + '</div>';
  }
  function render() {
    if (!cart) return;
    var empty = !cart.items.length, nd = empty ? null : nudge();
    var e = err ? '<p class="nmbc__err" role="alert">' + esc(err) + '</p>' : '';
    var main = empty ? emptyHTML() : e + cdHTML() + bar() + '<ul class="nmbc__ul">' + cart.items.map(function (i) { return line(i, nd && nd.key === i.key ? nd : null); }).join('') + '</ul>' + sugg();
    var rs = empty ? '' : '📦 ' + ship() + (C.reass ? '<br>' + esc(C.reass) : ''), rsd = empty ? '' : '📦 ' + ship() + ' · Retours 14 jours';
    if (dr) {
      dr.classList.toggle('is-empty', empty);
      dr.querySelector('[data-nmbc-main]').innerHTML = main;
      var dc = dr.querySelector('[data-nmbc-codes]'); if (dc) dc.innerHTML = empty ? '' : codes();
      var pn = dr.querySelector('[data-cart-drawer]'); if (pn) pn.classList.toggle('cart-drawer--empty', empty);
      dr.querySelector('[data-nmbc-sum]').innerHTML = empty ? '' : sum(true);
      dr.querySelector('[data-nmbc-rs]').innerHTML = rsd;
      var n = dr.querySelector('[data-nmbc-n]'); if (n) n.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    }
    if (pg) {
      pg.classList.toggle('is-empty', empty);
      pg.querySelector('[data-nmbc-main]').innerHTML = main;
      pg.querySelector('[data-nmbc-sum]').innerHTML = empty ? '' : codes() + sum();
      var r = pg.querySelector('[data-nmbc-rs]'); if (r) r.innerHTML = rs;
    }
  }
  function count() {
    cdTick();
    var n = cart.item_count;
    document.querySelectorAll('#cart-icon-bubble').forEach(function (a) {
      var t = a.querySelector('.nmbh__cart-t'); if (t) t.textContent = 'Panier (' + n + ')';
      var b = a.querySelector('.nmbh__cnt');
      if (n > 0) { if (!b) { b = document.createElement('span'); b.className = 'nmbh__cnt'; b.setAttribute('aria-hidden', 'true'); a.appendChild(b); } b.textContent = n; }
      else if (b) b.remove();
    });
  }
  function set(c) { cart = c; render(); count(); return c; }
  function load() { return api('cart.js').then(set); }
  function live(m) {
    var l = dr && dr.querySelector('[data-nmbc-live]');
    if (l && !dr.hidden) l.textContent = m; else toast(m);
  }
  function toast(m) {
    var t = document.querySelector('.nmbc-toast');
    if (!t) { t = document.createElement('div'); t.className = 'nmbc-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = m; t.classList.add('on'); clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }
  function setBusy(b) { busy = b; if (dr) dr.classList.toggle('is-busy', b); if (pg) pg.classList.toggle('is-busy', b); }
  function run(pr) {
    setBusy(true); err = '';
    return pr.then(set).catch(function (j) {
      err = (j && (j.description || j.message)) || 'Une erreur est survenue, réessaie dans un instant.';
      return load();
    }).then(function (c) { setBusy(false); return c; });
  }
  function change(key, q) { return run(api('cart/change.js', { id: key, quantity: Math.max(0, q) })); }
  function addItems(items) { return run(api('cart/add.js', { items: items }).then(function () { return api('cart.js'); })); }
  function setCodes(list) { return run(api('cart/update.js', { discount: list.join(',') })); }
  function applyCode(code) {
    code = up(code);
    return (cart ? Promise.resolve() : load()).then(function () {
      var l = codesList();
      if (l.map(up).indexOf(code) > -1) return cart;
      return api('cart/update.js', { discount: l.concat(code).join(',') }).then(set);
    }).catch(function () {});
  }

  /* ---------- ouverture / fermeture ---------- */
  function open() {
    if (!dr) { location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    dr.hidden = false;
    document.documentElement.classList.add('nmbc-lock');
    void dr.offsetWidth; /* force le recalcul pour que la transition démarre */
    dr.classList.add('is-on');
    var x = dr.querySelector('.nmbc__x'); if (x) x.focus({ preventScroll: true });
  }
  function close() {
    if (!dr || dr.hidden) return;
    dr.classList.remove('is-on');
    document.documentElement.classList.remove('nmbc-lock');
    setTimeout(function () { if (!dr.classList.contains('is-on')) dr.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- événements ---------- */
  function bind(el) {
    el.addEventListener('click', function (e) {
      var t = e.target.closest('[data-q],[data-rm],[data-add],[data-rmcode],[data-sugcode],[data-nmbc-x],a');
      if (!t || !el.contains(t)) return;
      if (t.hasAttribute('data-nmbc-x')) { close(); return; }
      if (t.tagName === 'A') { if (dr && dr.contains(t)) close(); return; }
      e.preventDefault();
      if (busy || !cart) return;
      if (t.hasAttribute('data-sugcode')) {
        var sc = up(t.dataset.sugcode), before = codesList();
        setCodes(before.concat(sc)).then(function (c) {
          var d = ((c && c.discount_codes) || []).filter(function (x) { return up(x.code) === sc; })[0];
          if (!d || !d.applicable) { toast('Le code ' + sc + ' ne s’applique pas à ton panier'); return setCodes(before); }
          toast('Code ' + sc + ' appliqué ✓'); live('Code ' + sc + ' appliqué');
        });
        return;
      }
      var li = t.closest('[data-key]'), it = li && cart.items.filter(function (i) { return i.key === li.dataset.key; })[0];
      if (t.hasAttribute('data-q') && it) change(it.key, it.quantity + (+t.dataset.q));
      else if (t.hasAttribute('data-rm') && it) change(it.key, 0);
      else if (t.hasAttribute('data-add')) addItems([{ id: +t.dataset.add, quantity: 1 }]).then(function () { live('Produit ajouté au panier'); });
      else if (t.hasAttribute('data-rmcode')) { var rc = up(t.dataset.rmcode); setCodes(codesList().filter(function (c) { return up(c) !== rc; })); }
    });
    el.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-codef]'); if (!f) return;
      e.preventDefault(); if (busy || !cart) return;
      var v = up((f.elements.c.value || '').trim()); if (!v) return;
      var list = codesList(); codeOpen = true;
      if (list.map(up).indexOf(v) > -1) { codeErr = 'Ce code est déjà appliqué.'; render(); return; }
      setCodes(list.concat(v)).then(function (c) {
        var d = ((c && c.discount_codes) || []).filter(function (x) { return up(x.code) === v; })[0];
        if (!d || !d.applicable) { codeErr = 'Le code ' + v + ' ne s’applique pas à ton panier.'; return setCodes(list); }
        codeErr = ''; codeOpen = false; render(); live('Code ' + v + ' appliqué');
      });
    });
    el.addEventListener('toggle', function (e) { if (e.target.classList && e.target.classList.contains('nmbc__cd')) codeOpen = e.target.open; }, true);
  }
  if (dr) bind(dr);
  if (pg) bind(pg);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dr && !dr.hidden) close(); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble');
    if (a && dr) { e.preventDefault(); open(); load(); return; }
    var p = e.target.closest('.pill[data-code]');
    if (p) {
      var code = p.dataset.code;
      try { navigator.clipboard && navigator.clipboard.writeText(code).catch(function () {}); } catch (x) {}
      applyCode(code).then(function () { toast('Code ' + code + ' ajouté à ton panier ✓'); });
    }
  });
  /* Le panier a changé hors de ce script (ex. bouton « Ajouter » de l'app Essential Upsell) : on recharge. */
  var extT = null;
  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(function (list) {
        if (muting > 0) return;
        if (list.getEntries().some(function (e) { return /\/cart\/(add|change|update|clear)/.test(e.name); })) {
          clearTimeout(extT); extT = setTimeout(function () { if (!busy && muting === 0) load(); }, 250);
        }
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }
  /* Titre de l'app d'upsell au tutoiement, comme le reste du site */
  function tuto(root) {
    root.querySelectorAll('div[data-essential-upsell-element="title"]').forEach(function (t) {
      t.childNodes.forEach(function (n) { if (n.nodeType === 3 && /votre/.test(n.textContent)) n.textContent = n.textContent.replace(/votre/g, 'ta'); });
    });
  }
  if (window.MutationObserver) document.querySelectorAll('.nmbc__eu').forEach(function (slot) {
    new MutationObserver(function () { tuto(slot); }).observe(slot, { childList: true, subtree: true, characterData: true });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted && (pg || cart)) load(); });
  if (pg) load();

  window.NMBCart = {
    open: function () { open(); return load(); },
    close: close,
    refresh: load,
    applyCode: applyCode,
    addForm: function (form, code) {
      muting++; setTimeout(function () { muting--; }, 4000);
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
        .then(function () { return code ? applyCode(code) : null; })
        .then(load)
        .then(function () { open(); live('Produit ajouté au panier'); });
    }
  };
})();
